import { render, staticRenderFns } from "./NeedsActivities.vue?vue&type=template&id=32900776&scoped=true&"
import script from "./NeedsActivities.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsActivities.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32900776",
  null
  
)

export default component.exports